import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import { translate } from "react-i18next";
import InsertZone from "./insert_zone";
import ReadAxios from "../../../components/axiosComponent/read";
import {TITLES} from './zone_constants'

class AddZone extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: "add_title",
            editData: {},
        };
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.title) {
            this.setState({
                title: this.props.location.state.title,
                editData: { ...this.props.location.state },
            });
        }
        this.props?.location?.state?.zoneId && this.getMappedStates()
    }    
    getMappedStates = ()=>{
        ReadAxios({completeURL: `${process.env.REACT_APP_MASTER_API}/zoneStateMapping/${this.props.location.state.zoneId}`}).then((result)=>{
            let stateIds = result.data.resultSet.length > 0 ?
            result.data.resultSet.map((mappings)=>{
                return mappings.stateId;
            }) 
            : []
            this.setState({
                editData : {...this.state.editData , stateIds}
            })
        }).catch((err)=>{
            console.log(err);
        })
    }

    onFormSubmit = () => {
        this.props.history.push("/zone");
        this.props.history.go();
    };
    render() {
        return (
            <React.Fragment>
                <AddTitleBar Title={this.state.editData.zoneId ? TITLES.edit : TITLES.add } LinkName="/zone" />
                <div className="m-2">
                    <InsertZone
                        editData={this.state.editData}
                        onFormSubmit={this.onFormSubmit}
                    />
                </div>
            </React.Fragment>
        );
    }
}
export default AddZone;
